<template>
    <div class="main-body">
        <div class="header">
            IC卡操作记录
        </div>
        <div class="out">
            <div class="search2">

                <div style="float:right">

                  <el-input  placeholder="请输入姓名" v-model.trim="name" clearable style="margin:0 10px;width:200px"></el-input>
                  <el-input  placeholder="请输入IC卡号" v-model="cardNumber" clearable style="margin:0 10px;width:200px"></el-input>
                  <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

                </div>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column prop="elderlyName" label="老人姓名"></el-table-column>
                <el-table-column prop="cardNumber" label="IC卡号"></el-table-column>
                <el-table-column prop="staffName" label="职工名称"></el-table-column>
                <el-table-column prop="content" label="操作记录"></el-table-column>
                 <el-table-column prop="createTime" label="操作时间" :formatter="timefilter"></el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                startTime:'',
                endTime:'',
                th:0,
                name:'',
                cardNumber:''
            }
        },
        // components:{
        //     Add,Edit
        // },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        components:{
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){
                this.endTime=timefilters(new Date()).slice(0,10)
                this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24*30)).slice(0,10)
            },
            dataChange(val){
                this.startTime=val[0]
                this.endTime=val[1]
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"CardRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        pageIndex:this.currentPage,
                        name:this.name,
                        pageSize:this.pageSize,
                        cardNumber:this.cardNumber
                    }
                }).then( (response)=> {
                    _this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.fromType == 1){
                    return "设备上传";
                }
                if(row.fromType == 2){
                    return "手动添加";
                }
                return "其它";
            },



        }
    }
</script>

<style scoped>

</style>
